import { useEffect } from "react";
import Box from "@mui/material/Box";
import DataGridTable from "./DataGridTable";
import ActionsPanel from "./ActionsPanel";
import Modals from "./Modals";
import { useMainContext } from "../../context/useMainContext";
import TableSkeleton from "../UI/TableSkeleton";

export default function MainContent() {
  const {
    rows,
    selected,
    selectAllCheckboxRef,
    setSelectAll,
    isInitialLoad,
  } = useMainContext();

  useEffect(() => {
    const currentPageIds = rows.map((row) => row.id);
    const filteredSelected = selected.filter((selectedItem) =>
      currentPageIds.includes(selectedItem.id)
    );
    const hasFilteredRows = rows.length > 0;
    const allSelected =
      hasFilteredRows && filteredSelected.length === rows.length;
    const someSelected =
      hasFilteredRows &&
      filteredSelected.length > 0 &&
      filteredSelected.length < rows.length;
    setSelectAll(allSelected);
    // Set indeterminate state and disabled state for checkbox
    if (selectAllCheckboxRef.current) {
      selectAllCheckboxRef.current.indeterminate = someSelected;
      selectAllCheckboxRef.current.disabled = !hasFilteredRows;
    }
  }, [selected, rows]);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100vw",
        height: {
          xs: "auto",
          xl: "calc(100vh - 64px)",
        },
        pt: 2,
        px: 1,
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <ActionsPanel />

      {isInitialLoad ? (
        <TableSkeleton />
      ) : (
        <DataGridTable />
      )}

      <Modals />
    </Box>
  );
}
